<template>
  <div>
    <div v-if="historyReport.loaded && !historyReport.error">
      <AddCommentModal ref="commentModal" :isVisible="showAddCommentModal"
                       @close="modalCloseHandler()">
      </AddCommentModal>
      <div class="row control-row">
        <div class="col-xs-12 col-md-12 col-lg-4 code-history-buttons"
             style="">
          <button class="btn btn-secondary"
                  :disabled="isPlaying"
                  @click="backwardHistory()"><i class="dev-skip-back"></i></button>
          <button class="btn btn-secondary btn-lg"
                  @click="decreaseSpeed()"><i class="dev-chevrons-left"></i></button>
          <button class="btn btn-secondary btn-lg fa"
                  @click="playHistory()"><i :class="{'dev-play': !isPlaying, 'dev-pause': isPlaying}"></i></button>
          <button class="btn btn-secondary btn-lg"
                  @click="increaseSpeed()"><i class="dev-chevrons-right"></i></button>
          <button class="btn btn-secondary btn-lg"
                  :disabled="isPlaying"
                  @click="forwardHistory()"><i class="dev-skip-forward"></i></button>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-3"
             style="z-index: 1000;">
          <div class="slider-wrapper">
            <input class="slider" id="version-slider"
                   type="range"
                   :min="0"
                   v-model.number="versionIndex"
                   :max="versions.length - 1"
                   :step="step"
                   @input="updateVersionCode(versionIndex)">
          </div>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-4 code-history-speed"
             style="margin-top: 0.3em; z-index: 1000;">
          <i class="dev-time"></i>
          {{ versionIndex }}
          /
          {{ versions.length - 1 }} |
          <i class="dev-chevrons-right"></i> {{
            100 /
            speed *
            100
          }}%
        </div>
      </div>
      <div class="row editor-row">
        <div class="col-xs-12 editor-col">
          <div v-if="!loaded && !error" style="height: 45vh;">
            <p class="text-center"
               style="position:absolute; top: 45%; width: 100%;">
                    <span class="loading-spinner loading-spinner-big loading-spinner-green"
                          style="color: #41a499; font-family: FontAwesome !important;">
                    </span>
            </p>
          </div>
          <quality-editor v-if="error"
                          height="45vh"
                          :code="errorCode"
                          language="javascript"
                          :minimap="false">
          </quality-editor>
          <quality-editor v-if="loaded && !error"
                          ref="solutionEditor"
                          height="45vh"
                          :language="this.language"
                          :code="currentVersionCode"
                          :previous-code="previousVersionCode"
                          :file-path="solution.filePath"
                          :minimap="false"
                          @loaded="registerCommentAction()"
                          @focused="codeIsSelected=true"
                          :folding="false"
                          @addCommentButtonClicked="openCommentWindow()">
          </quality-editor>
        </div>
      </div>
    </div>
    <div v-if="!historyReport.loaded && solutionRequest.loaded" style="height: 45vh;">
      <solution-editor-loading-indicator></solution-editor-loading-indicator>
    </div>
    <div v-if="historyReport.loaded && solutionRequest.loaded && solutionRequest.error" class="error-message">
      <img class="icon" src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1643639005/eh-platform/icons/smashicons_website_elements_website-error-28-icon-cartoony.svg">
      <span>Es ist ein <strong>Fehler</strong> beim Laden der Lösung aufgetreten :(</span>
    </div>
    <div v-if="historyReport.loaded && historyReport.error">
      Dein Quellcode wird noch analysiert. Schaue in ein paar Minuten nochmal nach.
    </div>
  </div>
</template>

<script>
    import QualityEditor from "../workspace/QualityEditor";
    import {eventBus, services} from "../../main";
    import AddCommentModal from "./AddCommentModal";
    import SolutionEditorLoadingIndicator from "../SolutionEditorLoadingIndicator";

    export default {
        name: "ExtendedSolutionEditorComponent",
        components: {SolutionEditorLoadingIndicator, AddCommentModal, QualityEditor},
        props: {
            solutionId: {type: String, required: false},
            language: {type: String, required: true}
        },
        data() {
            return {
                solutionRequest: services.rankTheCodeService.getSolution(this.solutionId),
                codeCommentsRequest: services.rankTheCodeService.getCodeComments(this.solutionId),
                publicUserProfilesRequestForSolution: {loaded: false, error: null},
                publicUserProfilesRequestForComments: {loaded: false, error: null},
                publicUserIdMap: new Map(),
                showAddCommentModal: false,
                codeIsSelected: false,
                errorCode: "// sorry EntwicklerHeld you see this code because you have not solved this challenge!\n" +
                    "function youHaveNotSolvedThisChallenge() {\n" +
                    "    return true;\n" +
                    "}\n",
                editorLoaded: false,
                historyReport: {loaded: false, error: null},
                isPlaying: false,
                versionIndex: 0,
                versions: [],
                currentVersionCode: "",
                previousVersionCode: "",
                speed: 100,
                step: 1,
                lastCommitIndex: 0,
            }
        },
        mounted() {
            eventBus.$on("rank-the-code-comments-updated", () => {
                this.reloadCodeComments();
            });
        },
        beforeDestroy() {
            eventBus.$off('rank-the-code-comments-updated');
        },
        computed: {
            loaded: function () {
                return this.solutionRequest.loaded;
            },
            error: function () {
                return this.solutionRequest.error;
            },
            solution: function () {
                return this.solutionRequest.apiData;
            },
            publicUserIds: function () {
                let publicUserIds = [];
                if (this.solutionRequest.loaded && !this.solutionRequest.error) {
                    publicUserIds.push(this.solutionRequest.apiData.publicUserId);
                }
                return publicUserIds;
            },
            codeCommentsWithUserData: function () {
                let codeCommentsList = [];
                if (!this.codeCommentsRequest.loaded || !this.publicUserProfilesRequestForComments.loaded) {
                    return codeCommentsList;
                }
                for (let codeComment of this.codeCommentsRequest.apiData) {
                    codeComment.user.userName = this.getUserName(codeComment.user.publicId);
                    codeComment.user.userImage = this.getUserImage(codeComment.user.publicId);
                    for (let commentForCodeComment of codeComment.comments) {
                        commentForCodeComment.userName = this.getUserName(commentForCodeComment.publicUserId);
                        commentForCodeComment.userImage = this.getUserImage(commentForCodeComment.publicUserId);
                    }
                    codeCommentsList.push(codeComment);
                }
                return codeCommentsList;
            },
            editorAndCommentsAreLoaded: function() {
                return this.editorLoaded && this.codeCommentsRequest.loaded && this.publicUserProfilesRequestForComments.loaded;
            },
            userId: function () {
              if (services.auth.getIDTokenPayload()) {
                return services.auth.getIDTokenPayload().sub;
              }
              return "";
            },
        },
        methods: {
            updateVersionCode(index) {
              this.currentVersionCode = this.versions[index].content;
              let previousVersionIndex = index - this.step;
              if (previousVersionIndex < 0) {
                previousVersionIndex = 0;
              }
              this.previousVersionCode = this.versions[previousVersionIndex].content;
            },
            playHistory() {
              if (this.isPlaying) {
                return this.stopHistory();
              }

              let versionIndex = parseInt(this.versionIndex);
              if (versionIndex === this.versions.length - 1) {
                this.versionIndex = 0;
              }

              let play = function () {
                if (!this.isPlaying) {
                  return;
                }
                let versionIndex = parseInt(this.versionIndex) + this.step;
                if (versionIndex >= this.versions.length) {
                  this.isPlaying = false;
                  return;
                }
                this.versionIndex = parseInt(versionIndex);
                setTimeout(play.bind(this), this.speed);
              };
              this.isPlaying = true;
              setTimeout(play.bind(this), this.speed);
            },
            stopHistory() {
              this.isPlaying = false;
            },
            forwardHistory() {
              this.versionIndex = this.versions.length - 1;
            },
            backwardHistory() {
              this.versionIndex = 0;
            },
            increaseSpeed() {
              let speed = Math.floor(this.speed / 2);
              if (speed < 25) {
                return;
              }
              this.speed = speed;
            },
            decreaseSpeed() {
              let speed = Math.floor(this.speed * 2);
              if (speed >= 1000) {
                return;
              }
              this.speed = speed;
            },
            getChallengeDetails() {
              let region = "";
              this.campaignRequest = services.taskManagementService.getChallengeDetails(
                  this.selectedChallengeId,
                  region
              );
            },
            registerCommentAction() {
                this.$refs.solutionEditor.initializeCodeCommentAddButtons();
                this.$refs.solutionEditor.editor.addAction({
                    // An unique identifier of the contributed action.
                    id: 'comment-code',

                    // A label of the action that will be presented to the user.
                    label: 'Code kommentieren',

                    // An optional array of keybindings for the action.
                    keybindings:
                        Object.keys(monaco.KeyCode).filter(key => monaco.KeyCode[key]),
                    // A precondition for this action.
                    precondition: null,

                    // A rule to evaluate on top of the precondition in order to dispatch the keybindings.
                    keybindingContext: null,

                    contextMenuGroupId: 'navigation',

                    contextMenuOrder: 1.5,

                    // Method that will be executed when the action is triggered.
                    // @param editor The editor instance is passed in as a convinience
                    run: (editor) => {
                      if(this.versionIndex === this.lastCommitIndex) {
                        let selection = editor.getSelection();
                        let range = {
                            startLineNumber: selection.startLineNumber,
                            startColumn: selection.startColumn,
                            endLineNumber: selection.endLineNumber,
                            endColumn: selection.endColumn,
                        };
                        this.$refs.commentModal.setSolutionId(this.solutionId);
                        this.$refs.commentModal.setRange(range);

                        let selectedCode = editor.getModel().getValueInRange(selection);
                        if (selectedCode === "") {
                            selectedCode = editor.getModel().getValueInRange(new monaco.Range(range.startLineNumber, 0, range.endLineNumber + 1, 0));
                        }
                        this.$refs.commentModal.setCode(selectedCode);
                        this.showAddCommentModal = true;
                        return null;
                      }
                    }
                });
                this.editorLoaded = true;
            },
            getUserName(publicUserId) {
                if (!this.publicUserIdMap.has(publicUserId)) {
                    return "Anonymer EntwicklerHeld"
                }
                return this.publicUserIdMap.get(publicUserId)["displayName"];
            },
            getUserImage(publicUserId) {
                if (!this.publicUserIdMap.has(publicUserId)) {
                    return "https://s3.amazonaws.com/s3-cuescience/anonym-user.png"
                }
                return this.publicUserIdMap.get(publicUserId)["profilePicture"];
            },
            updatePublicUserIdMap(requestData) {
                requestData.forEach(publicUserData => this.publicUserIdMap.set(publicUserData.publicUserId, {
                    displayName: publicUserData.displayName,
                    profilePicture: publicUserData.profilePicture
                }))
            },
            renderComments: function () {
              if(!this.editorAndCommentsAreLoaded){
                return;
              }

              if (this.versionIndex !== this.lastCommitIndex) {
                  this.$refs.solutionEditor.removeComments();
                  return;
              }
              this.$refs.solutionEditor.renderComments(this.codeCommentsWithUserData);
            },
            centerEditorFocus: function (comment) {
                this.$refs.solutionEditor.editor.revealLinesInCenterIfOutsideViewport(comment.range.startLineNumber, comment.range.endLineNumber, 0)
            },
            highlightComment(comment) {
              if(this.versionIndex === this.lastCommitIndex) {
                this.$refs.solutionEditor.highlightComment(comment.range);
              }
            },
            modalCloseHandler() {
                this.showAddCommentModal = false;
                this.$emit('addCommentModalClosed');
            },
            resetData() {
                this.$emit('userHasSolvedThisChallenge', false);
                this.codeIsSelected = false;
                this.editorLoaded = false;
                this.publicUserProfilesRequestForSolution = {loaded: false, error: null};
                this.publicUserProfilesRequestForComments = {loaded: false, error: null};
            },
            openCommentWindow() {
                this.$refs.solutionEditor.editor.getAction('comment-code').run();
            },
            reloadCodeComments() {
                this.codeCommentsRequest = services.rankTheCodeService.getCodeComments(this.solutionId)
            },
        },
        watch: {
            "solutionRequest.loaded": function () {
                if (this.solutionRequest.loaded && !this.solutionRequest.error) {
                    let publicUserIds = [this.solutionRequest.apiData.publicUserId];
                    this.publicUserProfilesRequestForSolution = services.userService.getDataForPublicUserIds(publicUserIds);
                    this.historyReport = services.qualityService.getHistoryReport(
                        this.solution.challengeId,
                        this.userId,
                        this.solution.filePath,
                        this.solution.taskId
                    )
                    this.$emit('userHasSolvedThisChallenge', true);
                }

            },
            "codeCommentsRequest.loaded": function () {
                if (this.codeCommentsRequest.loaded && !this.codeCommentsRequest.error) {
                    let publicUserIds = [];
                    for (let codeComment of this.codeCommentsRequest.apiData) {
                        publicUserIds.push(codeComment.user.publicId);
                        for (let commentForCodeComment of codeComment.comments) {
                            publicUserIds.push(commentForCodeComment.publicUserId);
                        }
                    }
                    this.publicUserProfilesRequestForComments = services.userService.getDataForPublicUserIds(publicUserIds);
                    this.$emit('userHasSolvedThisChallenge', true)
                }

            },
            "publicUserProfilesRequestForSolution.loaded": function () {
                if (this.publicUserProfilesRequestForSolution.loaded && !this.publicUserProfilesRequestForSolution.error) {
                    this.updatePublicUserIdMap(this.publicUserProfilesRequestForSolution.apiData);
                }
            },
            "publicUserProfilesRequestForComments.loaded": function () {
                if (this.publicUserProfilesRequestForComments.loaded && !this.publicUserProfilesRequestForComments.error) {
                    this.updatePublicUserIdMap(this.publicUserProfilesRequestForComments.apiData);
                }
            },
            "solutionId": function () {
                this.resetData();
                this.solutionRequest = services.rankTheCodeService.getSolution(this.solutionId);
                this.codeCommentsRequest = services.rankTheCodeService.getCodeComments(this.solutionId);
            },
            "editorAndCommentsAreLoaded": function () {
                if (this.editorAndCommentsAreLoaded) {
                    this.renderComments();
                }
            },
            'historyReport.loaded': function () {
                if (this.historyReport.loaded && !this.historyReport.error) {
                  this.versions = this.historyReport.history_report_data;
                  this.lastCommitIndex = this.versions.length - 1;
                  this.versionIndex = this.versions.length - 1;
                  this.currentVersionCode = this.versions[this.versionIndex].content;

                  let previousVersionIndex = this.versionIndex - this.step;
                  if (previousVersionIndex < 0) {
                    previousVersionIndex = 0;
                  }
                  this.previousVersionCode = this.versions[previousVersionIndex].content;
                }
              },
              'versionIndex': function () {
                this.updateVersionCode(this.versionIndex);
                this.renderComments();
              }
        }
    }
</script>

<style scoped>
    .control-row {
      margin: 2rem 0 1.5rem 0;
    }
    .editor-row {
        padding: 10px 0;
    }

    .editor-row .editor-col {
        padding-left: 0;
        padding-right: 0;
    }

    .active {
        opacity: 1.0;
    }

    .slider-wrapper input {
      width: 100%;
      margin-top: 0.5em;
    }

    .slider {
      -webkit-appearance: none;
      width: 100%;
      height: 15px;
      border-radius: 5px;
      background: #F2F7FD;
      outline: none;
      -webkit-transition: .2s;
      transition: opacity .2s;
    }

    .slider::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: #08AB99;
      cursor: pointer;
    }

    .slider::-moz-range-thumb {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: #08AB99;
      cursor: pointer;
    }

    .code-history-buttons {
      margin-bottom: 0.5rem;
    }

    @media (min-width: 300px) {
      .code-history-buttons {
        text-align: center;
      }

      .code-history-speed {
        text-align: center;
      }
    }

    @media (min-width: 768px) {
      .code-history-buttons {
        text-align: left;
        margin-bottom: 1rem;
      }

      .code-history-buttons .btn {
        padding: 6px 15px;
      }

      .code-history-speed {
        text-align: left;
      }

      .slider {
        margin-bottom: 0.5rem;
      }
    }

    @media (min-width: 1200px) {
      .code-history-buttons {
        text-align: right;
      }
    }

    @media (min-width: 1200px) {
      .code-history-buttons .btn {
        padding: 6px 9px;
      }
    }

    @media (min-width: 1360px) {
      .code-history-buttons .btn {
        padding: 6px 10px;
      }
    }

    .error-message {
      padding: 1.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .icon {
      height: 3rem;
      margin-right: 2rem;
    }
</style>
